<template>
  <div class="table-header" :class="{sortable: isSortable}" @click="switchSort">
    <div class="content d-flex align-center" :class="alignClass">
      <div>
        <slot />
      </div>
      <div v-if="isSortable" class="arrow" :class="sortOrder" />
    </div>
  </div>
</template>

<script>
export default {
  inject: ["sort", "updateSort"],

  props: {
    align: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    }
  },

  computed: {
    alignClass() {
      if (this.align === "left") {
        return "justify-start";
      }
      if (this.align === "right") {
        return "justify-end";
      }
      if (this.align === "center") {
        return "justify-center";
      }
      return "";
    },
    isSortable() {
      return this.name && this.sort;
    },
    sortOrder() {
      if (this.isSortable) {
        return this.name !== this.sort.name ? "default" : this.sort.order;
      }
      return "";
    }
  },

  methods: {
    switchSort() {
      if (this.name && this.sort) {
        this.updateSort({
          name: this.name,
          order: this.sortOrder !== "asc" ? "asc" : "desc"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table-header {
  display: table-cell;
  vertical-align: top;
  padding: 0 10px;
  border-bottom: 1px #ccc solid;
  color: #555;
  font-weight: bold;
  font-size: 12px;

  &.sortable {
    cursor: pointer;
  }
}

.content {
  min-height: 40px;
}

.arrow {
  margin-left: 4px;
  display: inline-block;
  border-right: 4px transparent solid;
  border-left: 4px transparent solid;

  &.default {
    border-top: 5px #ccc solid;
  }

  &.asc {
    border-bottom: 5px #333 solid;
  }

  &.desc {
    border-top: 5px #333 solid;
  }
}
</style>
